
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SnCardSearchComponent } from './components/sn-card-search/sn-card-search.component';
import { ConnectServerService } from '../../../../../services/connect-server.service';
import { SnSearch } from './sn-search';
import { ApiResponse } from '../../../../../interfaces/api-response';
import { SnSearchFilterService } from './sn-search-filter.service';

interface Pagination {
  currentPage: number;
  lastPage: number;
  total: number;
}

@Component({
    selector: 'app-sn-search',
    imports: [
    FormsModule,
    MatTooltipModule,
    SnCardSearchComponent
],
    templateUrl: './sn-search.component.html',
    styleUrl: './sn-search.component.scss'
})
export class SnSearchComponent {
  searchQuery: string = '';
  searchMade: boolean = false;
  error: boolean = false;

  // Pagination properties
  itemsPerPage: number = 50;
  currentPage: number = 1;
  totalResults: number = 0;
  totalPages: number = 1;
  paginatedData: SnSearch[] = [];

  constructor(
    private connectServerService: ConnectServerService,
    private searchFilterService: SnSearchFilterService
  ) {}

  ngOnInit(): void {
    this.restoreSearch();
  }

  private restoreSearch(): void {
    const savedState = this.searchFilterService.getFilters();

    if (savedState && savedState.searchQuery.length >= 5) {
      this.searchQuery = savedState.searchQuery;
      this.currentPage = savedState.currentPage;
      this.itemsPerPage = savedState.itemsPerPage;
      this.totalResults = savedState.totalResults;
      this.totalPages = savedState.totalPages;

      // Rifai la ricerca con i parametri salvati
      this.getResults();
    }
  }

  searchSN() {
    if (this.searchQuery.length < 5) {
      this.error = true;
    } else {
      this.error = false;
      this.currentPage = 1;
      this.getResults();
    }
  }

  reset() {
    this.searchQuery = '';
    this.error = false;
    this.searchMade = false;
    this.currentPage = 1;
    this.paginatedData = [];
    this.totalResults = 0;
    this.totalPages = 1;

    // Pulisci lo stato salvato
    this.searchFilterService.clearFilters();
  }

  getResults() {
    this.connectServerService
      .getRequestCookie('lavorazioni/searchDevicesBySerial', {
        query: this.searchQuery,
        itemsPerPage: this.itemsPerPage,
        currentPageIndex: this.currentPage
      })
      .subscribe((val: ApiResponse<{listResult: SnSearch[], pagination: Pagination}>) => {
        if (val.data) {

          // Normalizza i dati per assicurarsi che orders, systems, tickets, rma siano sempre array
          this.paginatedData = val.data.listResult.map(item => ({
            ...item,
            orders: this.normalizeToArray(item.orders),
            systems: this.normalizeToArray(item.systems),
            tickets: this.normalizeToArray(item.tickets),
            rma: this.normalizeToArray(item.rma)
          }));

          this.searchMade = true;
          this.totalResults = val.data.pagination.total;
          this.totalPages = val.data.pagination.lastPage;

          // Salva lo stato corrente
          this.searchFilterService.setFilters({
            searchQuery: this.searchQuery,
            currentPage: this.currentPage,
            itemsPerPage: this.itemsPerPage,
            totalResults: this.totalResults,
            totalPages: this.totalPages
          });
        }
      });
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage -= 1;
      this.getResults();
    }
  }

  nextPage() {
    if (this.totalPages > this.currentPage) {
      this.currentPage += 1;
      this.getResults();
    }
  }

  // Metodo per normalizzare i dati in array
  private normalizeToArray(data: any): any[] {
    if (!data) {
      return [];
    }

    if (Array.isArray(data)) {
      return data;
    }

    // Se è un oggetto singolo, lo wrappa in un array
    return [data];
  }
}
